
//------------------------------------------------------------------------------

//
const renderTemplate = require('./utils/renderTemplate.js');
const sessionStorage = require('./utils/sessionStorage.js');

//------------------------------------------------------------------------------

//
const totalAllowedCourses = 4;

//if the programme builder is not on the page then - all done
const programmeBuilder = document.querySelector('.programme-builder');
if (programmeBuilder == null) {
    return;
}

//
const programmeBuilderCourses = programmeBuilder.querySelectorAll('.programme-builder-course');
const tooManyCoursesWarning   = programmeBuilder.querySelector('.too-many-courses-warning')

//------------------------------------------------------------------------------

//
const renderProgrammeBuilderPricing = () => {

    //
    const selectedCourses = [];
    for (const course of programmeBuilder.querySelectorAll('.programme-builder-course[data-selected]')) { 
        selectedCourses.push({'courseID' : course.dataset.courseId, 'courseName' : course.dataset.courseName, 'normalPrice' : parseFloat(course.dataset.normalPrice), 'programmePrice' : parseFloat(course.dataset.programmePrice)});
    }

    //store the user's latest selection into session storage (in-case they leave and come back)
    sessionStorage.set('programme-builder-selection', selectedCourses.reduce((acc, item) => {
        acc.push(item.courseID);
        return acc;
    }, []));

    //
    const selectedCoursesCount = selectedCourses.length;

    //
    const normalTotal    = selectedCourses.reduce((acc, value) => { return acc + value['normalPrice']; }, 0);
    const programmeTotal = selectedCourses.reduce((acc, value) => { return acc + value['programmePrice']; }, 0);
    const totalSaved     = (normalTotal - programmeTotal);

    //pad the selected courses so we can see how many "slots" we are allowed
    for (var i = selectedCourses.length; i < totalAllowedCourses; i++) {
        selectedCourses.push({'courseName' : null});
    }

    //hide the warning about too many courses if it's visible
    tooManyCoursesWarning.removeAttribute('data-visible');

    //
    const programmeBuilderSelectionPanel = document.querySelector('.programme-builder-selection');
    programmeBuilderSelectionPanel.innerHTML = renderTemplate('programme-builder-selection-panel', {

        //
        'totalAllowedCourses'  : totalAllowedCourses,
        
        //
        'selectedCoursesCount' : selectedCoursesCount,
        'selectedCourses'      : selectedCourses,

        //
        'normalTotal'          : normalTotal,
        'programmeTotal'       : programmeTotal,
        'totalSaved'           : totalSaved,

    });

}

//------------------------------------------------------------------------------

//if the user has some previously selected course try to reload it 
if ((programmeBuilderSelection = sessionStorage.get('programme-builder-selection')) !== null) {
    for (const previouslySelectedCourse of programmeBuilderSelection) {
        if ((previouslySelectedCourseElement = programmeBuilder.querySelector(`.programme-builder-course[data-course-id="${previouslySelectedCourse}"]`)) !== null) {
            previouslySelectedCourseElement.setAttribute('data-selected', 'data-selected');
        }
    }
}

//
renderProgrammeBuilderPricing();

//------------------------------------------------------------------------------

//add an event to each course to manage the user's selection
for (const course of programmeBuilderCourses) {
    if ((toggleSelectionButton = course.querySelector('a[data-action="toggle-selection"]'))) {
        toggleSelectionButton.addEventListener('click', (event) => {

        	//
        	event.preventDefault();

            //if we are trying to select a new course, check to see if we have enough slots
            if (!course.hasAttribute('data-selected') && programmeBuilder.querySelectorAll('.programme-builder-course[data-selected]').length >= totalAllowedCourses) {
                tooManyCoursesWarning.setAttribute('data-visible', 'data-visible');
                return;
            }

            //
            course.toggleAttribute('data-selected');
            renderProgrammeBuilderPricing();

        });
    }
}

//------------------------------------------------------------------------------
